import { inject, Injectable } from '@angular/core';
import { AsyncHttpClient } from './async-http-client.service';
import { ImportResult } from '../../model';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(AsyncHttpClient);
  adminUpdateLocations = async () => this.http.post<any>('api/admin/import-locations', {});
  // `write` opts into a write transaction (app#392): default false = Neo4j READ access mode; true needs DB_ADMIN.
  adminExec = async (cypher: string, write = false) =>
    this.http.post<ImportResult[]>('api/admin/exec', { cypher, write });
  adminExecDownload = async (cypher: string) => this.http.postBlobXls('api/admin/exec-download', { cypher });
  exploreLandLink = async (id: string) => this.http.get<{ url: string }>(`api/explore-land/${encodeURI(id)}`);
  teams = async () => this.http.get('api/team/all');
}
